<template>
  <div class="pantalla-publica">
    <header class="encabezado">
      <div class="encabezado-texto">
        <div class="marca">PROVEEDORES LOCALES</div>
        <h1>Oportunidades de contratación</h1>
        <p>Conoce los requerimientos disponibles</p>
      </div>

      <div class="encabezado-derecha">

        <img
          :src="logoInstitucional"
          class="logo-institucional"
          alt="Southern Peru - Grupo México"
        >

        <div class="reloj">
          <div>{{ horaActual }}</div>
          <small>{{ fechaActual }}</small>
        </div>

      </div>
    </header>

    <div class="barra-info">
      <span>
        <span class="punto"></span>
        INFORMACIÓN ACTUALIZADA AUTOMÁTICAMENTE
      </span>
      <span>{{ oportunidadesVisibles.length }} oportunidades</span>
    </div>

    <main class="contenido">
      <div v-if="cargando && oportunidadesVisibles.length === 0" class="mensaje">
        Cargando oportunidades...
      </div>

      <div
        v-else-if="error && oportunidadesVisibles.length === 0"
        class="mensaje"
      >
        No se pudieron cargar las oportunidades. Se volverá a intentar automáticamente.
      </div>

      <div v-else-if="oportunidadesVisibles.length === 0" class="mensaje">
        Actualmente estamos consultando las oportunidades abiertas disponibles.
      </div>

      <div v-else class="lista-oportunidades">
        <article
          v-for="oportunidad in oportunidadesVisibles"
          :key="oportunidad.idrequerimiento"
          class="oportunidad"
        >
          <div class="logo-empresa">
            <img
              v-if="obtenerLogoEmpresa(oportunidad)"
              :src="obtenerLogoEmpresa(oportunidad)"
              :alt="obtenerNombreEmpresa(oportunidad)"
            >
            <div v-else class="logo-empresa-fallback">
              <span>{{ inicialesEmpresa(obtenerNombreEmpresa(oportunidad)) }}</span>
            </div>
          </div>

          <div class="informacion">
            <h2>
              <strong>{{ oportunidad.denominacion ? oportunidad.denominacion.slice(0, 3) : '' }}</strong>
              - {{ nombreRubro(oportunidad.rubro_tipo_servicio) }}
            </h2>

            <div class="categoria">
              {{ oportunidad.nombre_categoria || 'Servicio' }}
            </div>

            <div class="empresa">
              {{ obtenerNombreEmpresa(oportunidad) }}
            </div>

            <p v-if="oportunidad.observaciones" class="descripcion">
              {{ oportunidad.observaciones }}
            </p>

            <div
              v-if="oportunidad.detalles && oportunidad.detalles.length"
              class="detalles"
            >
              <div
                v-for="detalle in oportunidad.detalles"
                :key="detalle.iddetalles"
                class="detalle-item"
              >
                <span class="detalle-punto"></span>
                <span>
                  <strong v-if="detalle.cantidad">
                    {{ detalle.cantidad }}
                  </strong>
                  {{ detalle.detalle }}
                  <span v-if="detalle.servicio"> — {{ detalle.servicio }}</span>
                </span>
              </div>
            </div>

            <div class="fechas">
              <span>
                <span class="icono-fecha">📅</span>
                Publicado el {{ formatoFecha(oportunidad.fecha_solicitud) }}
              </span>
              <span v-if="oportunidad.fecha_inicio">
                <span class="icono-fecha">📅</span>
                Inicio: {{ formatoFecha(oportunidad.fecha_inicio) }}
              </span>
            </div>
          </div>

          <div class="estado-contenedor">
            <span class="estado abierto">ABIERTO</span>

            <div class="fecha-limite">
              <span>⏰</span>
              Fecha final {{ formatoFecha(oportunidad.fecha_fin) }}
              <strong>
                ({{ diasRestantes(oportunidad.fecha_fin) }} días)
              </strong>
            </div>
          </div>
        </article>
      </div>
    </main>

    <footer class="pie">
      <span>PROVEEDORES LOCALES</span>
      <span>Última actualización: {{ ultimaActualizacion || 'Pendiente' }}</span>
    </footer>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OportunidadesPublicas',

  data: function () {
    return {
      oportunidades: [],
      empresa_item: [],
      categorias_servicios: [],
      logoInstitucional: 'data:image/png;base64,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',
      horaActual: '',
      fechaActual: '',
      ultimaActualizacion: '',
      cargando: false,
      error: false,
      intervaloReloj: null,
      intervaloActualizacion: null,
      componenteDestruido: false
    }
  },

  computed: {
    oportunidadesVisibles: function () {
      var hoy = this.inicioDelDia(new Date())
      var fechaMinima = new Date(hoy.getTime())
      fechaMinima.setDate(fechaMinima.getDate() - 1)

      return this.oportunidades.filter(function (item) {
        if (!item || item.estado !== 'ABIERTO' || !item.fecha_fin) {
          return false
        }

        var fechaFin = this.convertirFecha(item.fecha_fin)

        if (!fechaFin) {
          return false
        }

        fechaFin = this.inicioDelDia(fechaFin)

        return fechaFin.getTime() >= fechaMinima.getTime()
      }, this).sort(function (a, b) {
        return this.convertirFecha(a.fecha_fin) - this.convertirFecha(b.fecha_fin)
      }.bind(this))
    }
  },

  created: function () {
    this.actualizarFechaHora()

    // Reloj: cada segundo
    this.intervaloReloj = setInterval(() => {
      this.actualizarFechaHora()
    }, 1000)

    // Primero carga los contratistas y después las oportunidades
    this.listarEmpresasContratistas().then(() => {
      if (!this.componenteDestruido) {
        this.cargarOportunidades()
      }
    })

    this.cargarCategorias()
  },

  beforeDestroy: function () {
    this.componenteDestruido = true

    if (this.intervaloReloj) {
      clearInterval(this.intervaloReloj)
      this.intervaloReloj = null
    }

    if (this.temporizadorActualizacion) {
      clearTimeout(this.temporizadorActualizacion)
      this.temporizadorActualizacion = null
    }
  },

  methods: {
    listarEmpresasContratistas: function () {
      return axios
        .get('/api/Contratistas/Listar')
        .then(response => {
          this.empresa_item = response.data || []
        })
        .catch(error => {
          console.error('Error cargando contratistas:', error)
          this.empresa_item = []
        })
    },
    async cargarCategorias() {
      try {
        const response = await axios.get("/api/CategoriaServicios/Listar");
        this.categorias_servicios = response.data;
      } catch (error) {
        console.error("Error cargando categorías:", error);
      }
    },
    cargarOportunidades: function () {
      var self = this

      if (this.cargando || this.componenteDestruido) {
        return
      }

      this.cargando = true
      this.error = false

      console.log(
        'CONSULTA API DE OPORTUNIDADES:',
        new Date().toLocaleTimeString('es-PE')
      )

      axios.get('/api/Requerimientos/ListarOportunidadesPublicas')
        .then(function (response) {
          var datos = response.data

          self.oportunidades = Array.isArray(datos) ? datos : []
          self.ultimaActualizacion = new Date().toLocaleTimeString('es-PE')
        })
        .catch(function (error) {
          console.error('Error al cargar oportunidades públicas:', error)
          self.error = true
        })
        .finally(function () {
          self.cargando = false

          if (!self.componenteDestruido) {
            self.programarActualizacion()
          }
        })
    },

    programarActualizacion: function () {
      var self = this

      // Evita tener más de un temporizador activo
      if (this.temporizadorActualizacion) {
        clearTimeout(this.temporizadorActualizacion)
      }

      console.log(
        'SIGUIENTE CONSULTA PROGRAMADA PARA:',
        new Date(Date.now() + 120000).toLocaleTimeString('es-PE')
      )

      this.temporizadorActualizacion = setTimeout(function () {
        self.temporizadorActualizacion = null
        self.cargarOportunidades()
      }, 120000)
    },

    actualizarFechaHora: function () {
      var ahora = new Date()

      this.horaActual = ahora.toLocaleTimeString('es-PE', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      })

      this.fechaActual = ahora.toLocaleDateString('es-PE', {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      })
    },

    convertirFecha: function (valor) {
      if (!valor) {
        return null
      }

      // Evita desfases de zona horaria en fechas recibidas como YYYY-MM-DD.
      if (typeof valor === 'string') {
        var coincidencia = valor.match(/^(\d{4})-(\d{2})-(\d{2})/)
        if (coincidencia) {
          return new Date(
            Number(coincidencia[1]),
            Number(coincidencia[2]) - 1,
            Number(coincidencia[3])
          )
        }
      }

      var fecha = new Date(valor)
      return isNaN(fecha.getTime()) ? null : fecha
    },

    inicioDelDia: function (fecha) {
      return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate())
    },

    formatoFecha: function (valor) {
      var fecha = this.convertirFecha(valor)

      if (!fecha) {
        return 'No especificada'
      }

      return fecha.toLocaleDateString('es-PE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    },

    diasRestantes: function (valor) {
      var fecha = this.convertirFecha(valor)

      if (!fecha) {
        return '-'
      }

      var hoy = this.inicioDelDia(new Date())
      var fechaFin = this.inicioDelDia(fecha)
      return Math.round((fechaFin.getTime() - hoy.getTime()) / 86400000)
    },

    obtenerNombreEmpresa: function (item) {
      if (!item) {
        return 'Empresa contratista'
      }

      // Buscar la empresa contratista relacionada
      var empresa = this.empresa_item.find(function (e) {
        return Number(e.id_empresa_contratista) ===
          Number(item.id_empresa_contratista)
      })

      if (empresa) {
        return empresa.empresa_contratista ||
          empresa.razonsocial ||
          empresa.nombre_comercial ||
          'Empresa contratista'
      }

      // Compatibilidad si el API público ya devuelve el nombre
      return item.nombre_empresa_contratista ||
        item.razonsocial_contratista ||
        item.nombre_contratista ||
        (item.empresa_contratista && (
          item.empresa_contratista.razonsocial ||
          item.empresa_contratista.nombre_comercial
        )) ||
        'Empresa contratista'
    },

    obtenerLogoEmpresa: function (item) {
      if (!item) return null

      var empresa = this.empresa_item.find(function (e) {
        return Number(e.id_empresa_contratista) ===
          Number(item.id_empresa_contratista)
      })

      if (empresa && empresa.logo_empresa) {
        return empresa.logo_empresa
      }

      return null
    },

    inicialesEmpresa: function (nombre) {
      if (!nombre) {
        return 'EMP'
      }

      var palabras = nombre.trim().split(/\s+/)
      if (palabras.length === 1) {
        return palabras[0].substring(0, 3).toUpperCase()
      }

      return (palabras[0].charAt(0) + palabras[1].charAt(0)).toUpperCase()
    },
    nombreRubro (idRubro) {
      // console.log(this.categorias_servicios)
      const rubro = this.categorias_servicios.find(
        c => c.id === idRubro
      )
      return rubro ? rubro.nombrecategoria : '—'
    },
  }
}
</script>

<style scoped>
.pantalla-publica {
  min-height: 100vh;
  background: #f1f5f9;
  color: #172033;
  display: flex;
  flex-direction: column;
  font-family: Arial, sans-serif;
}

/* Cabecera institucional */
.encabezado {
  background: #2d8c9e;
  color: white;
  padding: 12px 4%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.encabezado-texto {
  min-width: 0;
}

.marca {
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 3px;
  color: #e0f7fa;
  margin-bottom: 5px;
}

.encabezado h1 {
  font-size: clamp(22px, 2.4vw, 34px);
  line-height: 1.2;
  margin: 5px 0;
  font-weight: 400;
}

.encabezado p {
  margin: 4px 0 0;
  color: #effcff;
  font-size: 13px;
}

.encabezado-derecha {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  flex-shrink: 0;
}

.reloj {
  text-align: right;
  flex-shrink: 0;
}

.reloj div {
  font-size: clamp(24px, 2.5vw, 36px);
  font-weight: bold;
  line-height: 1.15;
  font-variant-numeric: tabular-nums;
}

.reloj small {
  display: block;
  font-size: 12px;
  text-transform: capitalize;
  margin-top: 5px;
}

.logo-institucional {
  background: #ffffff;
  padding: 10px 18px;
  width: 205px;
  height: 78px;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  display: block;
}

/* Barra de actualización */
.barra-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 9px 4%;
  background: white;
  border-bottom: 1px solid #dbe3ee;
  font-size: 12px;
  font-weight: bold;
}

.punto {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #16a34a;
  margin-right: 8px;
}

/* Listado */
.contenido {
  flex: 1;
  padding: 18px 4%;
}

.lista-oportunidades {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.oportunidad {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 16px 20px;
  background: white;
  border-radius: 10px;
  border-left: 5px solid #2d8c9e;
  box-shadow: 0 3px 10px rgba(15, 23, 42, .06);
}

.logo-empresa {
  width: 76px;
  height: 76px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(15, 23, 42, .08);
}

.logo-empresa img {
  width: 90%;
  height: 90%;
  object-fit: contain;
}

.logo-empresa-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2d8c9e;
  background: #e5f4f6;
  font-size: 19px;
  font-weight: bold;
}

.informacion {
  flex: 1;
  min-width: 0;
}

.informacion h2 {
  font-size: clamp(17px, 1.5vw, 24px);
  margin: 0 0 5px;
  line-height: 1.25;
  color: #172033;
  overflow-wrap: anywhere;
}

.categoria {
  color: #2d8c9e;
  font-weight: bold;
  font-size: 13px;
  margin-bottom: 4px;
}

.empresa {
  color: #d04b19;
  font-weight: bold;
  font-size: 13px;
  text-transform: uppercase;
  margin: 4px 0;
}

.descripcion {
  margin: 6px 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.45;
  white-space: pre-line;
}

.detalles {
  margin: 7px 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.detalle-item {
  display: flex;
  align-items: flex-start;
  gap: 7px;
}

.detalle-punto {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #2d8c9e;
  flex-shrink: 0;
  margin-top: 6px;
}

.fechas {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
  font-size: 11px;
  color: #64748b;
  margin-top: 8px;
}

.fechas span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.estado-contenedor {
  min-width: 165px;
  text-align: center;
  flex-shrink: 0;
}

.estado {
  display: inline-block;
  padding: 8px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: bold;
}

.estado.abierto {
  background: #dcfce7;
  color: #166534;
}

.fecha-limite {
  margin-top: 9px;
  padding: 8px;
  border-radius: 7px;
  background: #e6f4f6;
  color: #286d79;
  font-size: 11px;
  line-height: 1.5;
}

.fecha-limite strong {
  display: block;
  font-size: 13px;
}

.mensaje {
  text-align: center;
  padding: 60px 20px;
  font-size: 18px;
  color: #64748b;
}

.pie {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 4%;
  background: #246f7d;
  color: white;
  font-size: 11px;
}

/* Adaptación para pantallas pequeñas */
@media (max-width: 700px) {
  .encabezado {
    padding: 12px 16px;
    gap: 10px;
  }

  .marca {
    letter-spacing: 1px;
    font-size: 10px;
  }

  .encabezado h1 {
    font-size: 21px;
  }

  .encabezado p {
    font-size: 11px;
  }

  .encabezado-derecha {
    gap: 8px;
    flex-direction: column;
  }

  .reloj div {
    font-size: 21px;
  }

  .reloj small {
    font-size: 9px;
    max-width: 120px;
  }

  .logo-institucional {
    width: 105px;
    max-height: 42px;
  }

  .barra-info {
    font-size: 10px;
    padding: 8px 16px;
  }

  .contenido {
    padding: 12px;
  }

  .oportunidad {
    padding: 13px;
    gap: 11px;
    flex-wrap: wrap;
  }

  .logo-empresa {
    width: 58px;
    height: 58px;
  }

  .informacion {
    flex-basis: calc(100% - 72px);
  }

  .informacion h2 {
    font-size: 16px;
  }

  .empresa {
    font-size: 11px;
  }

  .estado-contenedor {
    width: 100%;
    text-align: left;
    padding-left: 69px;
  }

  .fecha-limite {
    display: inline-block;
    min-width: 180px;
  }

  .pie {
    flex-direction: column;
  }
  .icono-fecha {
    font-size: 13px;
  }
  /*.logo-institucional {
    background-color: #ffffff;
    padding: 8px 14px;
    border-radius: 8px;
    max-height: 65px;
    max-width: 190px;
    width: auto;
    height: auto;
    object-fit: contain;
    box-sizing: border-box;
  }*/
}
</style>
